import React, { useEffect, useState } from "react";
import BasicDetailsCp from "./BasicDetailsCp";
import OthersDetailsCp from "./OthersDetailsCp";
import DirectorInfo from "./DirectorInfo";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentMembership,
  setProcessData,
} from "../../redux/actions/processAction";
import { useLocation, useNavigate } from "react-router-dom";
import { GetMembershipList, getUserDetails } from "../../api/common";
import moment from "moment";
import { removeNullValues } from "../../utils/commonFunction";
import { store } from "../../redux/store";
import { clearAuthData } from "../../redux/actions/authActions";
import ReferenceDetailsForm from './ReferenceDetailsForm';

export default function MembershipForm() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(1);
  const [invalidForm, setInValidForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const { currentMembership } = useSelector((state) => state.process);
  const { data } = useSelector((state) => state.process);
  // console.log("data from redux store", data);
  const { id } = useSelector((state) =>
    state.auth && state.auth.user ? state.auth.user : { id: null }
  );

  /* tabs nav */
  const tabs =
    currentMembership?.name.toString().toLowerCase() === "star"
      ? [
          { id: 1, label: "Basic Details" },
          { id: 3, label: "Reference Details" },
          { id: 4, label: "Other Details" },
        ]
      : [
          { id: 1, label: "Basic Details" },
          { id: 2, label: "Director Information" },
          { id: 3, label: "Reference Details" },
          { id: 4, label: "Other Details" },
        ];

  const handleBack = () => {
    const isStarMembership = currentMembership?.name.toLowerCase() === "star";
    const isUpgradePath = pathname.includes("upgrade");

    if (currentTab > 1) {
      setCurrentTab(
        (prevTab) => prevTab - (isStarMembership && currentTab === 3 ? 2 : 1)
      );
    } else {
      const basePath = isUpgradePath
        ? "/app/upgrade/select-membership"
        : "/register/user/select-membership";
      navigate(basePath, { replace: true });
      dispatch(setCurrentMembership(null));
    }
  };

  const handleNext = () => {
    const isStarMembership = currentMembership?.name.toLowerCase() === "star";
    const isUpgradePath = pathname.includes("upgrade");
    const appId = data.app_id || data.plan_history?.app_id;
    const navigateToReview = (basePath) => {
      navigate(`${basePath}/application-review/${btoa(appId)}`, {
        replace: true,
      });
    };

    if (
      (isStarMembership && currentTab === tabs.length + 1) ||
      (!isStarMembership && currentTab === tabs.length)
    ) {
      const basePath = isUpgradePath ? "/app/upgrade" : "/register/user";
      navigateToReview(basePath);
    } else {
      setCurrentTab(
        (prevTab) => prevTab + (isStarMembership && currentTab === 1 ? 2 : 1)
      );
    }
  };

  const handleTab = (tab) => {
    setCurrentTab(tab);
  };

  const getUserData = async () => {
    // console.log("getUserData called");
    setLoading(true);
    try {
      const res = await getUserDetails(id);
      if (res.status === 200) {
        const respData = res.data.data;
        dispatch(
          setProcessData({
            ...removeNullValues(respData.plan_history),
            ...removeNullValues(respData),
            ...removeNullValues(data),
            incorporation_date: data.incorporation_date
              ? data.incorporation_date
              : respData.org_type === "company"
              ? moment(respData.company.incorporation_date).format("YYYY-MM-DD")
              : respData.org_type === "partnership"
              ? moment(respData.llp.incorporation_date).format("YYYY-MM-DD")
              : "",
            director: data.director
              ? typeof data.director === "string"
                ? JSON.parse(data.director)
                : data.director
              : respData.director
              ? JSON.parse(respData.director).filter(
                  (item) => item.name || item.mobile_number || item.email
                )
              : [{ name: "", mobile_number: "", email: "" }],
            app_id:
              respData.plan_history && respData.plan_history.app_id
                ? respData.plan_history.app_id
                : null,
          })
        );
        if (!currentMembership || currentMembership === null) {
          const memRes = await GetMembershipList();
          if (memRes.status === 200 && memRes.data.success) {
            const list = memRes.data.data;
            const currentMem = list.find(
              (item) => item.id === respData.plan_history.plan_id
            );
            dispatch(setCurrentMembership(currentMem));
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getUserData();
    } else {
      if (!currentMembership || currentMembership === null) {
        navigate("/register/user/select-membership", { replace: true });
      }
    }
  }, []); // eslint-disable-line

  const isApplicationFilled = async (id) => {
    // console.log("isApplicationFilled");
    try {
      const { data } = await getUserDetails(id);
      // console.log("isApplicationFilled api data", data);
      if (
        data &&
        data?.data &&
        data?.data?.plan_history &&
        data?.data?.plan_history?.app_filled
      ) {
        const isUpgradePath = pathname.includes("upgrade");
        if (!isUpgradePath) {
          store.dispatch(clearAuthData());
          navigate("/login", { replace: true });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (data?.id) {
      isApplicationFilled(data?.id);
    }
  }, [data?.id]); // eslint-disable-line

  return (
    <>
      <div className="customContainer">
        <div className="headingTexts ">
          <h2>Membership Form</h2>
          <p>
            you are applying under{" "}
            <span style={{ fontWeight: "600" }}>
              {currentMembership?.name} Membership
            </span>
          </p>
        </div>

        <nav
          className={
            "tabMenu " +
            (currentMembership?.name.toString().toLowerCase() === "star"
              ? "starMenu"
              : "")
          }
        >
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            {!loading &&
              tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`nav-link ${
                    tab.id === currentTab ? "active" : ""
                  }`}
                  id={`${tab.id}-tab`}
                  type="button"
                  role="tab"
                  onClick={() => handleTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div className={"tab-pane fade show active"} role="tabpanel">
            {currentTab === 1 && !loading && (
              <BasicDetailsCp
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
            {currentTab === 2 && !loading && (
              <DirectorInfo
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
            {currentTab === 3 && !loading && (
              <ReferenceDetailsForm
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
            {currentTab === 4 && !loading && (
              <OthersDetailsCp
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
